import { z } from "zod";

/** GET /user-ui-flow → the flow keys the current user has already seen. */
export const SeenUiFlowsResponseSchema = z.object({
	data: z.array(z.string()),
});

export type SeenUiFlowsResponse = z.infer<typeof SeenUiFlowsResponseSchema>;

/** POST /user-ui-flow/:flowKey → the recorded marker. */
export const UserUiFlowMarkerSchema = z.object({
	flowKey: z.string(),
	seenAt: z.string(),
});

export type UserUiFlowMarker = z.infer<typeof UserUiFlowMarkerSchema>;
